import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import store from '../../store/store'
import HeaderPerfil from '@/components/profile/profile'
import EuDropDown from '@/components/slideDown/slideDown'
import SearchBar from '@/components/searchBar/searchBar'
import { cityParser } from '@/plugins/city_parser'

@Component({
  components: {
    HeaderPerfil,
    EuDropDown,
    SearchBar
  }
})
export default class Header extends Vue {
  @Prop({ default: true }) showSubHeader

  // Actions
  @Action action_getCitiesInformation: any
  @Action action_getTraits: any
  @Action action_getCategoryById;

  // Getters
  @Getter getUser: any
  @Getter getUserPhoto: any
  @Getter getIsToken: any
  @Getter getCountry: any
  @Getter getCity: any
  @Getter getIsUnderMobile: any
  @Getter getIsTestUser
  @Getter getIsSelectCountry: any
  @Getter getTraits: any
  @Getter getOpenCart: any
  @Getter getOpenCategories;
  @Getter getIsXLScreen: any
  @Getter getCart: any
  @Getter getCurrentSuperCategory;
  @Getter getCurrentCategory;
  @Getter getOpenBurguerMenu;
  

  // Mutations
  @Mutation PATH_TEMPORAL: any
  @Mutation IS_SELECT_COUNTRY: any
  @Mutation OPEN_CART: any
  @Mutation CURRENT_SUPER_CATEGORY;
  @Mutation OPEN_CATEGORIES;
  @Mutation CURRENT_CATEGORY
  @Mutation OPEN_BURGUER_MENU;

  togglePerfil = false
  showModalCities = false
  searchValue = "";
  showSuggestions = false;
  isSubHeaderVisible = false;
  growSearchBar = false;
  openCategories = false;
  subscription = window.location;
  store = window.location;


  currentIndex = -1;

  get getShow() {
    const name = this.$route.name;
    return (
      name !== "checkout" &&
      name !== "tracker" &&
      name !== "resetPassword" &&
      name !== "city" &&
      name !== "login" &&
      name !== "login" &&
      name !== "pse-confirmation" &&
      name !== "payment-link-confirmation" &&
      name !== "loginCellphone" &&
      name !== "loginCellCode" &&
      name !== "loginRegister" &&
      name !== "loginReset" &&
      name !== "loginAccount"
    );
  }

  get showCartButton() {
    let response = true;
    const name = this.$route.name;
    if (
      name === "history_orders" ||
      name === "paymentmethod" ||
      name.includes("subscription") ||
      name.includes("openWeek")
    ) {
      response = false;
    }
    return response;
  }

  get getSuperCategories() {
    let response = [];
    if (this.getCity && this.getCity.super_categories && this.getCity.super_categories.length) {
      response = this.getCity.super_categories.filter((superCategory) => superCategory.is_active);
    }
    return response;
  }

  get showHeader() {
    let hide = [
      "login",
      "login",
      "loginCellphone",
      "loginCellCode",
      "createCellCode",
      "loginRegister",
      "loginReset",
      "loginAccount"
    ];
    return !hide.includes(this.$route.name);
  }

  get getProductsCounter() {
    const cart = this.getCart;
    if(cart && cart.cart_products) {
      const cartProducts = cart.cart_products;
      if (cartProducts.length) {
        let qty = 0;
        cartProducts.map((item) => {
          qty = item.quantity_total + qty;
        })
        return qty;
      } else {
        return 0;
      }
    }
  }

  get getCurrentCityFlagSrc() {
    if(this.getCity && this.getCity.id) {
      const cityId = this.getCity.id;
      let response = "/assets/images/banderas/";
      if(cityId === 3 || cityId === 4) {
        response += "co.svg";
      } else if(cityId === 5) {
        response += "mx.svg";
      } else {
        response += "co.svg";
      }
      return response;
    }
  }

  get getRouteName() {
    let response = "";
    if(this.$route && this.$route.name) {
      response = this.$route.name;
    }
    return response;
  }

  get getPasillosButtonLabel() {
    let response = "Pasillos";
    if (
      this.$route.name === "superCategories" &&
      this.getCurrentSuperCategory &&
      this.getCurrentSuperCategory.name
    ) {
      response = this._truncate(this.getCurrentSuperCategory.name);
    }
    return response;
  }

  @Watch('getCurrentSuperCategory')
  onCurrentSuperCategoryChange() {
    document.getElementById('main').scroll({ top: 0, left: 0, behavior: 'smooth' });
    document.getElementById("categoriesButton").classList.add("shaking");
    setTimeout(() => {
      document.getElementById("categoriesButton").classList.remove("shaking");
    }, 1000);
  }

  async mounted() {
    this.isSubHeaderVisible = true;
    if(!this.getTraits) {
      await this.action_getTraits();
    }
  }

  _goHome() {
    if (this.$route.fullPath.includes("mi-menu")) {
      this.$route.name !== "subscriptions_settingsNew" &&
        this.$router.replace({ name: "subscriptions_settingsNew" });
    } else {
      this.$router.replace({ name: "superCategories" });
    }
    localStorage.removeItem('is_tok')
  }

  _routeHome() {
    const country = this.getCountry.name.split(' ').join('-')
    const path = { name: 'country', params: { country } }
    this.$router.push('/')
  }

  _login() {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    this.PATH_TEMPORAL({ name, params, query })
    window.location.href = '/login'
  }

  _country() {
    this.IS_SELECT_COUNTRY(false);
  }

  // Sub header
  _toggleModalCities() {
    this.IS_SELECT_COUNTRY(false)
  }

  _onToggleCart() {
    this.OPEN_CART(!this.getOpenCart);
  }

  _onToggleSubheader(value: boolean) {
    this.isSubHeaderVisible = value;
  }

  _onGrowSearchBar(value) {
    this.growSearchBar = value;
  }

  hideElement() {
    if(this.growSearchBar) {
      return true;
    }
    return false;
  }

   updateSuperCategory(superCategory) {
    this.CURRENT_SUPER_CATEGORY(superCategory);
    this.OPEN_CATEGORIES(!this.getOpenCategories);
    try {
      this.$router.push({ name: 'superCategories', query: {
        pasillo: cityParser(superCategory.name)
      }});
    } catch (error) {
      // Do nothing
    }
  }

  isCurrentSuperCategory(superCategory) {
    let response = false;
    if(this.getCurrentSuperCategory && this.getCurrentSuperCategory.id && superCategory.id) {
      response = this.getCurrentSuperCategory.id === superCategory.id;
    }
    return response;
  }

   _toggleCategories() {
    this.currentIndex = -1;
    this.OPEN_CATEGORIES(!this.getOpenCategories);
    if(this.openCategories) {
      document.getElementById("categoriesButton").focus();
    } else {
      document.getElementById("categoriesButton").blur();
    }
  }

  async _refreshData() {
    const getCity = store.getters.getCity
      if(getCity) {
        await store.dispatch('action_getCity', 3);
        console.log(this.getCity.id);
      }
  }

  _displaySubCategories(index) {
    if(index !== this.currentIndex) {
      this.currentIndex = index;
    } else {
      this.currentIndex = -1;
    }
  }

  async goToFeaturedProducts() {
    const getCity = store.getters.getCity
      if(getCity) {
        await store.dispatch('action_getCity', 3);
        console.log(this.getCity.id);
      }
    if(this.getRouteName !== 'featuredProducts') {
      this.$router.push({ name: 'featuredProducts' });
      
    }
    this.OPEN_CATEGORIES(false);    
  }

  async goToCategory(superCategory, index) {
    const categoryId = superCategory.category_ids[index];
    try {
      const category = await this.action_getCategoryById(categoryId);
      if(category && category.id) {
        try {
         this.$router.replace({ name: "commerceCategory", params: { category_id: category.id }});
         this.CURRENT_SUPER_CATEGORY(category);
        } catch (error) {
          // Do nothing
        }
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo."
      });
    }
  }

  _onRoute(toName: string) {
    const currentRoute = this.$route;
    if(toName !== currentRoute.name) {
      this.$router.replace({ name: toName });
    } else {
      this.$router.go(0);
    }
    this.OPEN_BURGUER_MENU(false);
  }

  goToSubscription() {
    this.$router.push({
      path: "/mi-menu/inicio"
    });
    console.log(window.location);
  }

  goToStore() {
    this.$router.push({
      path: "/parati"
    });
    console.log(window.location);
    
  }

  _toggleBurguerMenu() {
    this.OPEN_BURGUER_MENU(!this.getOpenBurguerMenu);
  }

  _truncate(value: string) {
    let response = value;
    const maxChars = 20;
    if(this.getIsUnderMobile && value && value.length && value.length > maxChars) {
      response = value.substr(0, maxChars) + "...";
    }
    return response;
  }
}
